import { Button, Form, InputGroup } from 'react-bootstrap';
import { CountryFlag } from '../CountryFlag/CountryFlag';
import { getLanguageName } from '../../utils/utils';
import { useEffect, useState } from 'react';
import { faCertificate, faExclamation, faGlobe, faPlus, faPlusCircle, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MaskedIcon } from '../MaskedIcon/MaskedIcon';

const LanguageCodeInputComponent = ({
  disabled = false,
  value = '',
  onChange = (lang: string) => {},
  onErrorChange = (state: boolean) => {},
  onAdd = (lang: string) => true,
  autoFocus = false,
  inline = false,
  size = null,
}) => {
  const [internalState, setInternalState] = useState(value);
  const [isLanguageCodeValid, setIsLanguageCodeValid] = useState(false);
  const [languageName, setLanguageName] = useState(null);

  useEffect(() => {
    setLanguageName(getLanguageName(internalState));
    onChange(internalState);
  }, [internalState]);

  return (
    <Form.Group
      className={(() => {
        const classes = [];
        if (inline) classes.push('mb-0 w-100');
        return classes.join(' ');
      })()}
    >
      {!inline && (
        <Form.Label>
          Codice lingua <small className={'text-muted'}>(due lettere)</small>
        </Form.Label>
      )}
      <InputGroup size={size as any}>
        {inline && (
          <InputGroup.Prepend>
            <Button variant={'light'} style={{ pointerEvents: 'none', padding: '0 9px', color: 'white' }} className={'d-flex align-items-center'}>
              <FontAwesomeIcon icon={faGlobe} />
            </Button>
          </InputGroup.Prepend>
        )}
        <Form.Control
          isValid={internalState && isLanguageCodeValid && !!languageName}
          isInvalid={(() => {
            if (inline) return !!internalState && (!isLanguageCodeValid || !languageName);
            return !internalState || !isLanguageCodeValid || !languageName;
          })()}
          maxLength={2}
          disabled={disabled}
          value={internalState}
          autoFocus={autoFocus}
          placeholder={inline ? 'Codice lingua (due lettere)' : null}
          onChange={(e) => setInternalState(e.target.value.toLowerCase())}
        />
        {!!internalState && (
          <InputGroup.Append style={{ display: isLanguageCodeValid && !!languageName ? 'flex' : 'none' }}>
            <Button variant={'dark'} style={{ pointerEvents: 'none' }} className={'d-flex align-items-center'}>
              <CountryFlag
                language={internalState}
                size={size == 'sm' ? '20x15' : '28x21'}
                onErrorChange={(state) => {
                  setIsLanguageCodeValid(!state);
                  onErrorChange(state);
                }}
              />
              {!!isLanguageCodeValid && !!languageName && <span className={'ml-1'}>{languageName}</span>}
            </Button>
          </InputGroup.Append>
        )}
        {inline && (
          <InputGroup.Append>
            <Button
              variant={'primary'}
              disabled={!isLanguageCodeValid}
              onClick={() => {
                if (onAdd(internalState)) {
                  setInternalState('');
                  setIsLanguageCodeValid(false);
                }
              }}
            >
              <FontAwesomeIcon icon={faPlus} fixedWidth={true} />
            </Button>
          </InputGroup.Append>
        )}
      </InputGroup>
      {!inline && (
        <Form.Text>
          Inserire il codice <strong>ISO-639-1</strong> della lingua desiderata.{' '}
          <a href={'https://www.loc.gov/standards/iso639-2/php/code_list.php'} target={'_blank'}>
            Dove lo trovo?
          </a>
        </Form.Text>
      )}
    </Form.Group>
  );
};

export { LanguageCodeInputComponent as LanguageCodeInput };
